import { FC } from 'react'
import { Outlet } from 'react-router-dom'
import { Page } from '@revolut-internal/ui-kit'

import { ChatDebugTabs } from './components'

export const ChatDebug: FC = () => {
  return (
    <Page>
      <Page.Header>Chat debug</Page.Header>
      <Page.Tabs>
        <ChatDebugTabs />
      </Page.Tabs>
      <Page.Main size="narrow">
        <Outlet />
      </Page.Main>
    </Page>
  )
}
